var _polygon, _polygon2, _polygon3, _polygon4, _polygon5, _polygon6, _polygon7, _polygon8, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgKazakhstan = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 85.331 512 341.337",
    style: {
      enableBackground: "new 0 85.33 512 341.337"
    },
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    y: 85.331,
    style: {
      fill: "#00AFCA"
    },
    width: 512,
    height: 341.337
  }), /*#__PURE__*/React.createElement("rect", {
    y: 85.331,
    style: {
      fill: "#FFD100"
    },
    width: 26,
    height: 341.337
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#FFD100"
    }
  }, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "246,249 246,263 312,256"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "227.58,293.48 237.48,283.58 279.2,335.2"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "193,302 207,302 200,368"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    points: "162.52,283.58 172.42,293.48 120.8,335.2"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    points: "154,249 154,263 88,256"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    points: "172.42,218.52 162.52,228.42 120.8,176.8"
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    points: "207,210 193,210 200,144"
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    points: "237.48,228.42 227.58,218.52 279.2,176.8"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 200,
    cy: 256,
    r: 38
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFD100"
    },
    d: "M124,338c16,-14 38,-18 56,-10c8,4 14,4 20,0c18,-8 40,-4 56,10 c-16,10 -38,12 -56,4c-6,-3 -14,-3 -20,0c-18,8 -40,6 -56,-4z"
  }));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgKazakhstan);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "kazakhstan.cee82f7ad8131f82af2f75dad9dfc3e2.svg";